import { TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../../Application";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { AnimatedObstacle } from "../../GameObjects/Obstacles/AnimatedObstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class Dinosaur extends AnimatedObstacle {
    private static readonly SPEED: number = -75;
    private static readonly Y_POS: number = 200;

    private _stompSfxTimer: TimelineMax;

    constructor() {
        super(
            new HLF.SpriteAnimation(
                "dinosaur-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "01", 12, 2,
                12, true,
            ),
            Dinosaur.SPEED,
            new BoxCollider(60, 160, -100, 120),
        );
        this.position.y = Dinosaur.Y_POS;
        this._collisionSfx = SFX.IMPACT_DINOSAUR;

        this._stompSfxTimer = new TimelineMax({
            repeat: -1,
        });
        this._stompSfxTimer.call(() => {
            Application.instance.audio.play(SFX.DINOSAUR_STOMP, 0.15, false, HLF.AudioCategory.SFX);
        }, undefined, this, 0.5);
    }

    public cleanup(): void {
        this._stompSfxTimer.kill();
    }
}
